import { formatDate } from 'base/src/utils/stringUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { CampanhaPedidoResgateResponse } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse';
import { Tag } from 'base/src/components/Tag';
import * as S from '../styles';

export interface TabPedidoProps {
  campanhaPedidoResgate: CampanhaPedidoResgateResponse;
}

export function TabPedido({ campanhaPedidoResgate }: TabPedidoProps) {
  return (
    <S.ExtratoContainer>
      <S.ExtratoHeader>
        <S.ExtratoTitle>Detalhes do Pedido</S.ExtratoTitle>
        <S.ExtratoDescription>
          Informações completas sobre o pedido de resgate
        </S.ExtratoDescription>
      </S.ExtratoHeader>

      <S.PedidoCard>
        {campanhaPedidoResgate.Premiacao.ImagemUrl && (
          <S.PedidoImageContainer>
            <S.PremiacaoImagem
              src={campanhaPedidoResgate.Premiacao.ImagemUrl}
              alt={campanhaPedidoResgate.Premiacao.Titulo}
            />
          </S.PedidoImageContainer>
        )}

        <S.PedidoContent>
          <S.PedidoHeader>
            <S.PedidoTitle>{campanhaPedidoResgate.Premiacao.Titulo}</S.PedidoTitle>
            <Tag variant='primary'>
              {formatDate(campanhaPedidoResgate.HoraPedido)}
            </Tag>
          </S.PedidoHeader>

          <S.PedidoDetails>
            <S.PedidoDetailRow>
              <S.PedidoDetailLabel>📅 Data de Solicitação</S.PedidoDetailLabel>
              <S.PedidoDetailValue>
                {formatDate(campanhaPedidoResgate.HoraPedido)}
              </S.PedidoDetailValue>
            </S.PedidoDetailRow>

            <S.PedidoDivider />

            <S.PedidoDetailRow>
              <S.PedidoDetailLabel>💵 Valor do Pedido</S.PedidoDetailLabel>
              <S.PedidoDetailValue>
                {formatToBRL(campanhaPedidoResgate.ValorOriginal)}
              </S.PedidoDetailValue>
            </S.PedidoDetailRow>

            <S.PedidoDetailRow>
              <S.PedidoDetailLabel>📊 Valor da Taxa</S.PedidoDetailLabel>
              <S.PedidoDetailValue isTax>
                {formatToBRL(campanhaPedidoResgate.ValorTaxa)}
              </S.PedidoDetailValue>
            </S.PedidoDetailRow>

            <S.PedidoDivider />

            <S.PedidoDetailRow>
              <S.PedidoDetailLabel>💰 Valor Total</S.PedidoDetailLabel>
              <S.PedidoDetailValueTotal>
                {formatToBRL(campanhaPedidoResgate.ValorTotal)}
              </S.PedidoDetailValueTotal>
            </S.PedidoDetailRow>
          </S.PedidoDetails>
        </S.PedidoContent>
      </S.PedidoCard>
    </S.ExtratoContainer>
  );
}
